module.exports = __webpack_public_path__ + "static/img/WechatIMG376.5f29398b.jpeg";